import React from "react";
import { StyleSheet, View } from "react-native";

import { Spacings } from "@/styling/spacings";
import { publicImagesUploadPromptsCount } from "@/utils/onboarding";

type Props = {
  renderImage: (index: number) => React.JSX.Element;
};

function OnboardingImageGrid({ renderImage }: Props): React.JSX.Element {
  // Create an array of indices based on the smartUploadPromptsCount
  const indices = Array.from(
    { length: publicImagesUploadPromptsCount },
    (_, i) => i,
  );

  const imagesPerRow = 3;
  const rowCount = Math.ceil(indices.length / imagesPerRow);

  // Create rows array
  const rows = Array.from({ length: rowCount }, (_, rowIndex) =>
    indices.slice(rowIndex * imagesPerRow, (rowIndex + 1) * imagesPerRow),
  );

  return (
    <View style={styles.container}>
      {rows.map((rowIndices, rowIdx) => (
        <View style={styles.row} key={rowIdx}>
          {rowIndices.map((idx) => (
            <View style={{ flex: 1 }} key={idx}>
              {renderImage(idx)}
            </View>
          ))}
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: Spacings.s1,
    columnGap: Spacings.s1, // spacing between columns, this is works together with card width calculation
  },
});

export default OnboardingImageGrid;
